<template>
  <IQOS :title="$t('worker_profile.tips_title')" required enabled>
    <div class="iqos-comment qrw-paragraph-md mt-16">
        {{ $t('worker_profile.tips_cafe_balance') }}
      </div>
      <div class="balance  mt-8 qrw-heading-xl">{{currency.symbol}}{{ waiter.tips_balance }}</div>
      <div class="payout mt-16">
          <BaseInput
            :disabled="!waiter.tips_balance"
            type="number"
            class="w-100"
            position="center"
            fullWidth
            v-model.number="payout"
            placeholder="₴0"
          />
          <BaseButton
            variant="primary"
            color="v1-grey-10"
            class="w-100 ml-8"
            size="md"
            @click="doPayout"
            :disabled="
              !waiter.tips_balance || !payout || payout > waiter.tips_balance
            "
          >
            {{ $t("worker_profile.tips_payout") }}
          </BaseButton>
        </div>
  </IQOS>
</template>

<script>
import WaitersAPI from "@/api/waiters";

export default {

  props: {
    waiter: Object,
  },
  data() {
    return {
      payout: null,
    };
  },
  methods: {
    doPayout() {
      WaitersAPI.withdrawTips(this.waiter._id, this.payout)
        .then((data) => {
          this.$emit("payout", data.waiter);
          this.payout = null;
        })
        .catch((error) => {
          alert(error);
        });
    },
  },
  computed: {
    currency() {
      return this.$store.state.currency;
    },
  },
};
</script>

<style scoped>
.balance {
  padding: 8px 16px;
  width: 100%;
  border-radius: 4px;
  color: var(--green-5-color);
  text-align: center;
  border: 1px solid var(--green-5-color);
  box-sizing: border-box;
}

.payout {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
</style>
